// 顧客宛文書
import { DocumentStatus } from '../types/CustomerDocument';

// ステータス
export const document_status: DocumentStatus = {
  1: '未承認',
  2: '承認済み',
  3: '掲載中',
  4: '掲載終了',
  5: '削除承認待ち',
  6: '削除済み',
};
